var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('div',{ref:"errors",staticClass:"alert alert-danger"},_vm._l((_vm.errorsTranslated),function(error,index){return _c('ul',{key:'error' + index,staticClass:"mb-0 pl-3"},[_c('li',{staticClass:"text-danger"},[_vm._v(_vm._s(error))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }